<template>
  <v-container grid-list-md>
    <v-layout row wrap>
      <v-flex xs12 sm8>
        <v-text-field name="nome" required v-model="medico.nome" label="Nome"></v-text-field>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field name="cpf" type="number" required v-model="medico.cpf" label="CPF"></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 sm4>
        <v-text-field name="crm" required v-model="medico.crm" label="CRM"></v-text-field>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field name="crmUf" required v-model="medico.crmUf" label="CRM UF (sigla)"></v-text-field>
      </v-flex>
    </v-layout>


    <v-layout row wrap v-if="medico.id">
      <v-flex xs12 sm4>
        <v-text-field prepend-icon="attach_file" single-line v-model="medico.certificado" label="certificado" @click.native="onFocus" ref="fileTextField"></v-text-field>
        <input type="file" accept="*" :multiple="false" ref="fileInput" @change="onFileChange">
      </v-flex>

      <v-flex xs12 sm4>
        <v-text-field name="senhaCertificado"
        v-model="medico.senhaCertificado"
        label="Senha Certificado"
        :append-icon="mostrarSenha ? 'visibility' : 'visibility_off'"
        :append-icon-cb="() => (mostrarSenha = !mostrarSenha)"
        :type="mostrarSenha ? 'password' : 'text'"></v-text-field>
      </v-flex>

      <v-flex xs12 sm4>
        <v-text-field
          label="Vencimento Certificado"
          v-model="dataVencimentoCertificado"
          prepend-icon="event"
          readonly
        ></v-text-field>

      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 sm4>
        <v-switch label="Ativo" color="primary" v-model="medico.ativo"></v-switch>
      </v-flex>
    </v-layout>
  </v-container>

</template>

<script>
  import moment from 'moment'
  moment.locale('pt-BR')

  export default {

    name: 'medico-form',
    props: {
      medico: {}
    },
    data () {
      return {
        mostrarSenha: true
      }
    },
    components: {
    },
    computed: {
      dataVencimentoCertificado () {
        return moment(this.medico.dataVencimentoCertificado).format('DD/MM/YYYY hh:mm')
      }
    },
    methods: {
      getFormData (files) {
        const data = new FormData()
        for (let file of files) {
          data.append('files[]', file, file.name)
        }
        return data
      },
      onFocus () {
        if (!this.disabled) {
          this.$refs.fileInput.click()
        }
      },
      onFileChange ($event) {
        const files = $event.target.files || $event.dataTransfer.files
        const form = this.getFormData(files)
        if (files) {
          if (files.length > 0) {
            this.medico.certificado = [...files].map(file => file.name).join(', ')
          }
        } else {
          this.medico.certificado = $event.target.value.split('\\').pop()
        }
        this.medico.formData = form
        // this.$emit('input', this.medico.certificado)
        // this.$emit('formData', form)
      }
    }
  }
</script>

<style scoped>

  input[type=file] {
      position: absolute;
      left: -99999px;
  }
</style>



// WEBPACK FOOTER //
// MedicoForm.vue?7b927ae4